import {
  Table,
  Space,
  Pagination,
  Image,
  Spin,
  Popconfirm,
  notification,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import axios from "axios";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { getDateHandler, month, date } from "../../utils/date";
import { Link, useNavigate } from "react-router-dom";

interface DataType {
  key: string;
  name: string;
  email: string;
  orderid: number;
}

const Products = () => {
  const naviagte = useNavigate();
  // contact data usestate
  const [contactData, setContactData]: any = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState("");

  // method for API call
  const getContactHandler = (page: any) => {
    setLoader(true);
    //axios call
    axios
      .get(
        `${process.env.REACT_APP_FRONTED_URL}/products?locale=en&page=${page}`
      )
      .then((response) => {
        console.log("res", response);
        setContactData(response?.data?.data);
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  //  API for contact
  useEffect(() => {
    getContactHandler(currentPage);
    // eslint-disable-next-line
  }, []);

  // confirm handler to delete record
  const confirm = (data: any) => {
    setSelectedRecord(data?.id);

    // API call to delete selected record
    axios
      .delete(
        `${process.env.REACT_APP_FRONTED_URL}/products/${data?.id}?locale=en`
      )
      .then(() => {
        // to delete locally from our database
        const remaingRecords = contactData?.data?.filter(
          (item: any) => item?.id !== data?.id
        );
        setContactData({ ...contactData, data: remaingRecords });
        // success message
        notification.open({
          message: "Success",
          description: "Product Deleted Successfully",
        });
        setSelectedRecord("");
      })
      .catch((error) => {
        notification.open({
          message: "Error",
          description: error?.message,
        });
        // message.error("Error");
        setSelectedRecord("");
      });
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Profile Image",
      dataIndex: "first_image",
      key: "first_image",
      render: (data) => (
        <Image
          width={80}
          height={80}
          style={{ borderRadius: "50%" }}
          src="error"
          fallback={
            data !== ""
              ? data
              : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
          }
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Category",
      key: "category",
      dataIndex: "category",
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (data: any) => (
        <Space size="middle">
          {getDateHandler(data) +
            "-" +
            month[date?.getMonth()] +
            "-" +
            date?.getFullYear()}
        </Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (data) => (
        <div className="flex">
          <EditOutlined
            className="cursor-pointer text-[20px]"
            onClick={() => {
              naviagte("/edit-product/" + data?.id);
            }}
          />{" "}
          {data?.id === selectedRecord ? (
            <Spin className=" mx-2" />
          ) : (
            <Popconfirm
              title="Delete the event"
              description="Are you sure to delete this event?"
              onConfirm={() => confirm(data)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined className="cursor-pointer text-[20px] mx-2" />
            </Popconfirm>
          )}
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="pt-2 pb-5 flex justify-between">
        <h1 className="text-[18px] font-semibold">All Products</h1>{" "}
        {/* add event */}
        <Link to="/add-product">
          <button className="cursor-pointer border border-[#620926] bg-[#620926] px-3 py-1 text-white rounded">
            Add Product
          </button>
        </Link>
      </div>
      <Table
        columns={columns}
        dataSource={contactData?.data}
        pagination={false}
        loading={loader}
        scroll={{ x: 1023 }}
      />
      {/* Pagination */}
      <Pagination
        defaultPageSize={currentPage}
        showSizeChanger={false}
        current={currentPage}
        pageSize={
          contactData !== undefined && contactData?.length !== 0
            ? contactData?.per_page
            : 1
        }
        total={contactData?.total}
        onChange={(e) => {
          setCurrentPage(e);
          getContactHandler(e);
        }}
        className="pagination"
      />
    </>
  );
};
export default Products;
